module.exports = __webpack_public_path__ + "assets/img/honor5.12505cbb.png";